function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBirthdayHat = function SvgBirthdayHat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff709d"
    },
    d: "M217.252 77.494h-22.141c-4.585 0-8.303-3.716-8.303-8.303s3.717-8.303 8.303-8.303h22.141c4.585 0 8.303 3.716 8.303 8.303s-3.717 8.303-8.303 8.303zM316.888 77.494h-22.141c-4.587 0-8.303-3.716-8.303-8.303s3.716-8.303 8.303-8.303h22.141c4.587 0 8.303 3.716 8.303 8.303s-3.717 8.303-8.303 8.303zM212.945 120.55a8.303 8.303 0 0 1-5.871-14.174l15.657-15.657a8.303 8.303 0 0 1 11.741 11.743l-15.657 15.657a8.278 8.278 0 0 1-5.87 2.431zM283.398 50.097c-2.124 0-4.25-.81-5.871-2.431a8.3 8.3 0 0 1-.001-11.741l15.656-15.657a8.3 8.3 0 0 1 11.741-.001 8.3 8.3 0 0 1 .001 11.741l-15.656 15.657a8.273 8.273 0 0 1-5.87 2.432zM228.601 50.097c-2.124 0-4.25-.81-5.871-2.431l-15.657-15.657a8.303 8.303 0 0 1 11.741-11.743l15.657 15.657a8.303 8.303 0 0 1-5.87 14.174zM299.054 120.55c-2.126 0-4.25-.81-5.872-2.432l-15.656-15.657a8.3 8.3 0 0 1 .001-11.741 8.302 8.302 0 0 1 11.741.001l15.656 15.657a8.3 8.3 0 0 1-.001 11.741 8.274 8.274 0 0 1-5.869 2.431zM256 38.747a8.303 8.303 0 0 1-8.303-8.303V8.303A8.302 8.302 0 0 1 256 0a8.301 8.301 0 0 1 8.303 8.303v22.141A8.302 8.302 0 0 1 256 38.747z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e60048"
    },
    d: "M256 96.868 105.609 459.945c87.978 69.407 212.805 69.407 300.783 0L256 96.868z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffd3c7"
    },
    cx: 344.561,
    cy: 437.278,
    r: 33.212
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffd3c7"
    },
    cx: 255.996,
    cy: 437.278,
    r: 33.212
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffd3c7"
    },
    cx: 167.431,
    cy: 437.278,
    r: 33.212
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffd3c7"
    },
    cx: 255.996,
    cy: 215.866,
    r: 33.212
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffd3c7"
    },
    cx: 300.279,
    cy: 326.572,
    r: 33.212
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffd3c7"
    },
    cx: 211.714,
    cy: 326.572,
    r: 33.212
  }));
};
export default SvgBirthdayHat;